import {Route} from 'vue-router'
import {ValidateFunc} from '@/project'

const isFallbackLink: ValidateFunc = (to: Route) => {
  const regex = /^\/link\/?/
  const {redirectedFrom = '', path = ''} = to
  return regex.test(redirectedFrom) || regex.test(path)
}

export default isFallbackLink
